// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"87c461f8c3b06420f202","5338":"648d2a8ac026a28862bf"}[chunkId] + ".js";
};